var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.hasText ? '-title' : '-text',staticStyle:{"min-height":"24px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.hasText)?_c('div',{staticClass:"-text",domProps:{"textContent":_vm._s(_vm.shownText)}}):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }